import { useQuery } from '@tanstack/react-query';
import { modelsApi } from '@/lib/api/models.api';

export function useActiveModels() {
  return useQuery({
    queryKey: ['models', 'active'],
    queryFn: () => modelsApi.listActive(),
  });
}
